import "core-js/modules/es6.function.name";
import _defineProperty from "/var/www/fiction/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { books, deleteAudit, cateInfo_list, authorInfo_list, searchCate, searchAuthor, searchBook } from '@/api/books'; // import Sortable from 'sortablejs'

import Pagination from '@/components/Pagination'; // 分页

export default {
  name: 'DragTable',
  components: {
    Pagination: Pagination
  },
  filters: {
    statusFilter: function statusFilter(status) {
      var statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger'
      };
      return statusMap[status];
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      list: [],
      total: null,
      listLoading: false
    }, _defineProperty(_ref, "total", 0), _defineProperty(_ref, "listQuery", {
      page: 1,
      // 第几页
      limit: 10 // 一条显示几条

    }), _defineProperty(_ref, "name", ''), _defineProperty(_ref, "classify", ''), _defineProperty(_ref, "author", ''), _defineProperty(_ref, "status", ''), _defineProperty(_ref, "ClassifyList", []), _defineProperty(_ref, "AuthorList", []), _defineProperty(_ref, "statusList", ['成功', '失败']), _defineProperty(_ref, "fenlei", ''), _defineProperty(_ref, "zuozhe", ''), _ref;
  },
  created: function created() {
    this.getList();
    this.GetClassify();
    this.GetAuthor();
  },
  methods: {
    // 搜索结果
    inquire: function inquire() {
      var _this = this;

      var bookname = this.name;
      var cate = this.classify;
      var author = this.author;
      var status = this.status;
      var page = this.listQuery.page;
      var limit = this.listQuery.limit;
      searchBook({
        bookname: bookname,
        cate: cate,
        author: author,
        status: status,
        page: page,
        limit: limit
      }).then(function (res) {
        console.log(res);
        page = res.page;
        limit = res.limit;
        _this.list = res.data;
      });
    },
    // 分类输入搜索
    gaibian: function gaibian() {
      var _this2 = this;

      console.log(this.fenlei);
      var catename = this.fenlei;
      searchCate({
        catename: catename
      }).then(function (res) {
        console.log(res);
        _this2.ClassifyList = res.data;
      });
    },
    // 获取分类
    GetClassify: function GetClassify() {
      var _this3 = this;

      cateInfo_list().then(function (res) {
        console.log(res);
        _this3.ClassifyList = res.data;
      });
    },
    // 获取作者
    GetAuthor: function GetAuthor() {
      var _this4 = this;

      authorInfo_list().then(function (res) {
        console.log(res);
        _this4.AuthorList = res.data;
      });
    },
    // 输入作者搜索
    seek: function seek() {
      var _this5 = this;

      var authorname = this.zuozhe;
      searchAuthor({
        authorname: authorname
      }).then(function (res) {
        console.log(res);
        _this5.AuthorList = res.data;
      });
    },
    // 获取状态
    Getstatus: function Getstatus() {},
    // 编辑
    handleUpdate: function handleUpdate(row) {
      console.log(row);
      this.$router.push({
        path: 'child',
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    getList: function getList() {
      var _this6 = this;

      books(this.listQuery).then(function (res) {
        console.log(res);
        _this6.list = res.data;
        _this6.total = res.total;
      });
    },
    handleCreate: function handleCreate() {
      //指定跳转的地址
      this.$router.push({
        path: 'child'
      });
    },
    // 删除
    handleDelete: function handleDelete(row, index) {
      var _this7 = this;

      console.log(row, index);
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteAudit({
          id: row.id
        }).then(function (response) {
          // console.log(response,6666666666666);return false;
          if (response.code == 0) {
            _this7.dialogFormVisible = false;

            _this7.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            });

            _this7.list.splice(index, 1);
          } else {
            _this7.$notify({
              title: '失败',
              message: response.msg,
              type: 'error',
              duration: 2000
            });
          }
        });
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};